import { NgModule } from '@angular/core';
import { TRUCK_JOURNEY_ROUTES } from './truck-journey.routes';
import { RouterModule } from '@angular/router';
import { TruckJourneyListComponent } from './components/list/truck-journey-list.component';
import { SharedModule } from '../../shared/shared.module';
import { ReportsModule } from '../../reports/reports.module';
import { CoreModule } from '../../core/core.module';
import { ManageTruckJourneysGuard } from '../../core/guards/manage-truck-journeys.guard';
import { TruckJourneySearchComponent } from './pages/search/truck-journey-search.component';
import { TruckJourneyService } from './services/truck-journey.service';
import { TruckJourneyEditionComponent } from './pages/edition/truck-journey-edition.component';
import { TruckJourneyLoadComponent } from './components/load/truck-journey-load.component';
import { TruckJourneyEditLoadComponent } from './components/edit-load/truck-journey-edit-load.component';
import {
  TruckJourneyLoadAssignmentOverlayComponent
} from './components/load-assignment/overlay/truck-journey-load-assignment-overlay.component';
import { CarrierSyncComponent } from './components/carrier-sync/carrier-sync.component';
import { TruckJourneyComponent } from './truck-journey.component';
import {
  TruckJourneyLoadAssignmentPageComponent
} from './pages/load-assignment/truck-journey-load-assignment-page.component';
import { TruckJourneyInfoComponent } from './components/truck-journey-info/truck-journey-info.component';
import { TruckJourneyDeliveryComponent } from './components/delivery/truck-journey-delivery.component';
import {
  TruckJourneyLoadAssignmentComponent
} from './components/load-assignment/content/truck-journey-load-assignment.component';
import { TruckJourneyResolverService } from './services/truck-journey-resolver.service';
import { HiddenDeliveriesTooltipComponent } from './components/hidden-deliveries-tooltip/hidden-deliveries-tooltip.component';
import { DeliveryNumberComponent } from './components/delivery-number/delivery-number.component';

const pages: any[] = [
  TruckJourneyComponent,
  TruckJourneyEditionComponent,
  TruckJourneyLoadAssignmentPageComponent,
  TruckJourneySearchComponent
];

const components: any[] = [
  CarrierSyncComponent,
  DeliveryNumberComponent,
  HiddenDeliveriesTooltipComponent,
  TruckJourneyDeliveryComponent,
  TruckJourneyEditLoadComponent,
  TruckJourneyInfoComponent,
  TruckJourneyListComponent,
  TruckJourneyLoadAssignmentComponent,
  TruckJourneyLoadAssignmentOverlayComponent,
  TruckJourneyLoadComponent
];

@NgModule({
  imports: [
    RouterModule.forChild(TRUCK_JOURNEY_ROUTES),
    SharedModule,
    ReportsModule,
    CoreModule
  ],
  declarations: [pages, components],
  exports: [],
  providers: [ManageTruckJourneysGuard, TruckJourneyService, TruckJourneyResolverService]
})
export class TruckJourneyModule {
}
